import script from "./HomeViewSwith.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeViewSwith.vue?vue&type=script&setup=true&lang=js"

import "./HomeViewSwith.vue?vue&type=style&index=0&id=7f48a24a&lang=css"

const __exports__ = script;

export default __exports__